import React, { Component } from 'react'
import { Provider } from 'react-redux'
import reducers from '../../reducers'
import Page from './page'
import { createStore, applyMiddleware } from 'redux'
import promise from 'redux-promise'
import thunkMiddleware from 'redux-thunk'
import multi from 'redux-multi'
import { composeWithDevTools } from 'redux-devtools-extension'

const middleware = composeWithDevTools(applyMiddleware(promise, multi, thunkMiddleware))

const store = createStore(reducers, middleware)

export default class LoginSmart extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (<Provider store={store}>
            <Page options={this.props} />
        </Provider>)

    }
}
